module.exports = __webpack_public_path__ + "img/tlf_sum4.fd277046.png";